'use client';

import ConfirmSizeSection from './components/ConfirmSizeSection';
import Gen3SizeGuideModal from './components/Gen3SizeGuideModal';
import Gen3VideoModal from './components/Gen3VideoModal';
import Gen4SizeGuideModal from './components/Gen4SizeGuideModal';
import Gen4VideoModal from './components/Gen4VideoModal';
import SizingGuidesSection from './components/SizingGuidesSection';
import SizingPageHero from './components/SizingPageHero';
import SizingPageModalProvider from './contexts/SizingPageModalProvider';

const Content = () => {
  return (
    <SizingPageModalProvider>
      <Gen4VideoModal />
      <Gen4SizeGuideModal />
      <Gen3VideoModal />
      <Gen3SizeGuideModal />
      <SizingPageHero />
      <ConfirmSizeSection />
      <SizingGuidesSection />
    </SizingPageModalProvider>
  );
};

export default Content;
